const cards = [
  {
    id: 1,
    title: '2024年度国产剧王：繁花凭什么封神？',
    desc: '王家卫十年磨一剑，胡歌领衔全明星阵容，沪上风云再现荧幕。深度解析繁花的艺术成就与时代意义。',
    tag: '深度解读',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shanghai%20cityscape%20in%201990s%20with%20neon%20lights%20and%20warm%20nostalgic%20atmosphere%2C%20cinematic%20lighting%2C%20film%20noir%20style%2C%20dramatic%20composition%2C%20no%20people%2C%20no%20text&width=700&height=460&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '悬疑片爱好者的年度片单：10部烧脑神作',
    desc: '从西班牙悬疑到日式推理，盘点近年最值得一看的高分悬疑电影，每一部都让你欲罢不能。',
    tag: '片单推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mysterious%20atmospheric%20room%20with%20dramatic%20lighting%20and%20shadows%2C%20detective%20noir%20vibe%2C%20warm%20amber%20accents%2C%20cinematic%20composition%2C%20moody%20aesthetic%2C%20no%20people%2C%20no%20text&width=700&height=460&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '国产动画崛起之路：从大圣到哪吒的蜕变',
    desc: '回顾中国动画电影十年发展历程，看国漫如何从低谷走向世界舞台，技术与艺术的完美融合。',
    tag: '行业观察',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20style%20landscape%20with%20vibrant%20colors%20and%20traditional%20elements%2C%20dreamy%20atmosphere%2C%20artistic%20composition%2C%20warm%20golden%20lighting%2C%20fantasy%20scene%2C%20no%20people%2C%20no%20text&width=700&height=460&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '港片不死：周星驰电影中的草根精神',
    desc: '星爷的喜剧背后藏着怎样的社会关怀？重温经典，解读周星驰电影中永不褪色的人文温度。',
    tag: '经典重温',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20old%20street%20at%20night%20with%20neon%20signs%20and%20wet%20pavement%2C%20nostalgic%20vintage%20atmosphere%2C%20warm%20cinematic%20lighting%2C%201990s%20film%20aesthetic%2C%20no%20people%2C%20no%20text&width=700&height=460&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '科幻迷必看：流浪地球系列的世界观构建',
    desc: '从行星发动机到数字生命，解读中国科幻电影如何打造属于东方的宏大叙事与视觉奇观。',
    tag: '影评解析',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20cityscape%20with%20massive%20structures%20and%20dramatic%20lighting%2C%20epic%20scale%2C%20warm%20orange%20and%20cool%20blue%20contrast%2C%20cinematic%20composition%2C%20no%20people%2C%20no%20text&width=700&height=460&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '追剧指南：2024下半年最值得期待的10部新剧',
    desc: '古装、悬疑、都市、科幻全品类覆盖，提前锁定下半年必追剧单，不再错过任何一部好剧。',
    tag: '追剧指南',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20cozy%20living%20room%20with%20a%20TV%20screen%20and%20warm%20ambient%20lighting%2C%20cinematic%20atmosphere%2C%20comfortable%20home%20theater%20setup%2C%20soft%20evening%20glow%2C%20no%20people%2C%20no%20text&width=700&height=460&seq=card-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精彩推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">深度影评与片单推荐，发现更多好内容</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card) => (
            <div
              key={card.id}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[3/2] w-full overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-primary-500/90 text-white text-xs font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
                <div className="flex items-center gap-3 mt-4 pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">
                    <i className="ri-eye-line mr-1"></i>
                    {Math.floor(Math.random() * 5000 + 1000).toLocaleString()} 阅读
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">
                    <i className="ri-time-line mr-1"></i>
                    {Math.floor(Math.random() * 7 + 1)} 天前
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}